// Taşeron portalı — ortak araç çekmecelerinin (`VehicleFormSheet`, `PermitVehicleAddSheet`) bağı:
// araç kaydı §23.2 (`supplierContractorApi`), izne bağlama §23.4 (`supplierPermitApi`).
// companyId anahtarda → firma değişiminde önceki firmanın araçları servis edilmez.

import {
  type VehicleClient,
  supplierContractorApi,
  supplierPermitApi,
  useAuthStore,
} from '@isgportal/shared';
import { useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { supplierContractorKeys } from './supplierContractorKeys';
import { invalidateVehicleCaches } from './vehicleCache';

export function useVehicleClient(): VehicleClient {
  const queryClient = useQueryClient();
  const companyId = useAuthStore((s) => s.principal?.companyId ?? null);
  return useMemo<VehicleClient>(
    () => ({
      registryKey: supplierContractorKeys.vehicles(companyId),
      registryEnabled: true,
      listRegistry: () => supplierContractorApi.listSupplierVehicles(),
      saveVehicle: (uuid, body) =>
        uuid === null
          ? supplierContractorApi.createSupplierVehicle(body)
          : supplierContractorApi.updateSupplierVehicle(uuid, body),
      linkToPermit: (permitUuid, body) =>
        supplierPermitApi.addSupplierPermitVehicle(permitUuid, body),
      invalidate: () => invalidateVehicleCaches(queryClient, companyId),
    }),
    [companyId, queryClient],
  );
}
